import { AUTUMN, SPRING, SUMMER, WINTER } from "./consts";

import { Plant } from "./model";

const plants = [
  {
    id: 0,
    name: "Asparagus" as const,
    growthFormula: 1,
    compost: -2,
    manure: 1,
    seasons: WINTER | SPRING,
    water: 1,
  },
  {
    id: 1,
    name: "Corn" as const,
    growthFormula: 1,
    compost: -2,
    manure: 1,
    seasons: AUTUMN | SPRING | SUMMER,
    water: 1,
  },
  {
    id: 2,
    name: "Garlic" as const,
    growthFormula: 2,
    compost: -4,
    manure: 2,
    seasons: AUTUMN | WINTER | SPRING | SUMMER,
    water: 1,
  },
  {
    id: 3,
    name: "Durian" as const,
    growthFormula: 2,
    compost: -4,
    manure: 2,
    seasons: SPRING,
    water: 1,
  },
  {
    id: 4,
    name: "Dragon Fruit" as const,
    growthFormula: 2,
    compost: 2,
    manure: -4,
    seasons: SPRING | SUMMER,
    water: 2,
  },
  {
    id: 5,
    name: "Pepper" as const,
    growthFormula: 2,
    compost: 2,
    manure: -4,
    seasons: AUTUMN | SUMMER,
    water: 1,
  },
  {
    id: 6,
    name: "Pomegranade" as const,
    growthFormula: -4,
    compost: 2,
    manure: 2,
    seasons: SPRING | SUMMER,
    water: 2,
  },
  {
    id: 7,
    name: "Onion" as const,
    growthFormula: -4,
    compost: 2,
    manure: 2,
    seasons: AUTUMN | SPRING | SUMMER,
    water: 2,
  },

  {
    id: 8,
    name: "Eggplant" as const,
    growthFormula: 1,
    compost: 1,
    manure: -2,
    seasons: AUTUMN | SPRING,
    water: 2,
  },
  {
    id: 9,
    name: "Potato" as const,
    growthFormula: 1,
    compost: 1,
    manure: -2,
    seasons: AUTUMN | WINTER | SPRING,
    water: 1,
  },
  {
    id: 10,
    name: "Carrot" as const,
    growthFormula: -2,
    compost: 1,
    manure: 1,
    seasons: AUTUMN | WINTER | SPRING,
    water: 1,
  },
  {
    id: 11,
    name: "Pumpkin" as const,
    growthFormula: -2,
    compost: 1,
    manure: 1,
    seasons: AUTUMN | WINTER,
    water: 3,
  },
  {
    id: 12,
    name: "Tomato" as const,
    growthFormula: -1,
    compost: -1,
    manure: 2,
    seasons: AUTUMN | SPRING | SUMMER,
    water: 3,
  },
  {
    id: 13,
    name: "Watermelon" as const,
    growthFormula: 2,
    compost: -1,
    manure: -1,
    seasons: SPRING | SUMMER,
    water: 3,
  },
];

export type PlantName = typeof plants[number]["name"];
export type PlantId = typeof plants[number]["id"];

const ignore: string[] = ["Durian", "Pomegranade", "Watermelon", "Eggplant"]; // Put plant names here
export const uselessVeggies: Plant[] = ignore.map(
  (name) => plants.find((plant) => plant.name === name) as Plant
);

export { plants };
